/**
 * 语言类型枚举
 * @description 使用国家代码作为统一标识符，避免 cn/zh 混用
 */
enum LangType {
  zh = 'CN',
  hk = 'HK',
  en = 'EN',
  my = 'MY',
  id = 'ID'
}

export default LangType